<template>
  <div class="experiences">
    <div v-for="(experience, index) in experiences">
      <div class="gallery">
        <div v-for="image in experience.images">
          <img v-bind:src="image.url"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { deliveryClient } from '@/kontent.js'

  export default {
    name: 'experiences',
    props: ['limit'],
    data: function() {
      return {
        experiences: []
      }
    },
    created: function(){
      var query = deliveryClient
      .items()
      .type('ervaringsgebied')
      .toPromise()
      .then(response => {
        this.$data.experiences = response.items.map(item => ({
          title: item.titel_van_ervaringsgebied.value,
          images: item.logo_s_van_bedrijven_om_ervaring_aan_te_tonen.value,
        }))
      })
    }
  }
</script>
